import {
  CarrierType,
  CarrierVisitDirection,
  GlobalAllocationRuleDto,
  GlobalAllocationRulesApi,
  GlobalAllocationRulesApiGlobalAllocationRulesCreateGlobalRuleAndAllocationRequest,
} from '@storage/app/api'

export class GlobalAllocationRuleService {
  constructor(private api: GlobalAllocationRulesApi) {}

  async get(
    direction?: CarrierVisitDirection,
    carrierType?: CarrierType,
  ): Promise<Array<GlobalAllocationRuleDto>> {
    const { data: globalAllocationRules } = await this.api.globalAllocationRulesGet({
      direction,
      carrierType,
    })
    return globalAllocationRules
  }

  async create(
    request?: GlobalAllocationRulesApiGlobalAllocationRulesCreateGlobalRuleAndAllocationRequest,
  ): Promise<void> {
    await this.api.globalAllocationRulesCreateGlobalRuleAndAllocation(request ?? {})
  }
}
